<script lang="ts">
    import { LL } from "../../../i18n/i18n-svelte";
    import type { Game } from "../../Phaser/Game/Game";
    import type { SelectCompanionScene } from "../../Phaser/Login/SelectCompanionScene";
    import { SelectCompanionSceneName } from "../../Phaser/Login/SelectCompanionScene";
    import { collectionsSizeStore, selectedCollection } from "../../Stores/SelectCharacterSceneStore";
    import { analyticsClient } from "../../Administration/AnalyticsClient";
    import { IconChevronLeft, IconChevronRight } from "@wa-icons";

    interface Props {
        game: Game;
    }

    let { game }: Props = $props();

    let selectCompanionScene = $derived(game.scene.getScene(SelectCompanionSceneName) as SelectCompanionScene);

    /*function selectLeft() {
        selectCompanionScene.moveToLeft();
    }

    function selectRight() {
        selectCompanionScene.moveToRight();
    }*/

    function noCompanion() {
        selectCompanionScene.noCompagnion().catch((e) => console.error(e));
    }

    function selectCompanion() {
        selectCompanionScene.selectCompanion().catch((e) => console.error(e));
    }

    function selectLeftCollection() {
        selectCompanionScene.selectPreviousCompanionCollection();
    }

    function selectRightCollection() {
        selectCompanionScene.selectNextCompanionCollection();
    }
</script>

<div class="nutrivera-entry-screen pointer-events-none fixed inset-0 z-20">
    <section
        class="pointer-events-auto absolute inset-x-3 top-6 z-30 mx-auto flex max-w-xl flex-col items-center gap-3 rounded-[var(--nutrivera-shell-radius)] border border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-bg)] p-4 text-center"
    >
        <span class="text-lg font-semibold text-[var(--nutrivera-shell-text)]">
            {$LL.companion.select.title()}
        </span>
        <div class="category flex flex-row items-center justify-center gap-2">
            {#if $collectionsSizeStore > 1 && $selectedCollection}
                <button
                    class="nutrivera-entry-secondary selectCharacterButton px-3"
                    onclick={(event) => {
                        event.preventDefault();
                        selectLeftCollection();
                    }}
                >
                    <IconChevronLeft />
                </button>
                <strong class="category-text">{$selectedCollection}</strong>
                <button
                    class="nutrivera-entry-secondary selectCharacterButton px-3"
                    onclick={(event) => {
                        event.preventDefault();
                        selectRightCollection();
                    }}
                >
                    <IconChevronRight />
                </button>
            {/if}
        </div>
    </section>
    <div
        class="pointer-events-auto fixed inset-x-0 bottom-0 z-40 border-t border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-bg)] pb-[env(safe-area-inset-bottom)]"
    >
        <section class="action mx-auto flex max-w-3xl flex-col-reverse gap-2 p-3 sm:flex-row sm:p-4">
            <button
                class="nutrivera-entry-secondary selectCompanionSceneFormBack block w-full px-4 md:w-1/2"
                onclick={(event) => {
                    event.preventDefault();
                    noCompanion();
                }}
            >
                {$LL.companion.select.any()}
            </button>
            <button
                type="submit"
                class="nutrivera-entry-primary selectCompanionSceneFormSubmit block w-full px-4 font-semibold md:w-1/2"
                onclick={(event) => {
                    event.preventDefault();
                    analyticsClient.selectCompanion();
                    selectCompanion();
                }}
            >
                {$LL.companion.select.continue()}
            </button>
        </section>
    </div>
</div>

<!--<form class="selectCompanionScene">-->
<!--    <section class="text-center">-->
<!--        <h2 class="text-white text-2xl">{$LL.companion.select.title()}</h2>-->
<!--        {#if $collectionsSizeStore > 1 && $selectedCollection}-->
<!--            <button-->
<!--                class="outline mr-2 selectCompanionCollectionButton selectCharacterButtonLeft"-->
<!--                onclick|preventDefault={selectLeftCollection}-->
<!--            >-->
<!--                &lt;-->
<!--            </button>-->
<!--            <strong class="category-text">{$selectedCollection}</strong>-->
<!--            <button-->
<!--                class="outline ml-2 selectCompanionCollectionButton selectCompanionButtonRight"-->
<!--                onclick|preventDefault={selectRightCollection}-->
<!--            >-->
<!--                &gt;-->
<!--            </button>-->
<!--        {/if}-->
<!--        <button class="outline selectCharacterButton selectCharacterButtonLeft" onclick|preventDefault={selectLeft}>-->
<!--            &lt;-->
<!--        </button>-->
<!--        <button class="outline selectCharacterButton selectCharacterButtonRight" onclick|preventDefault={selectRight}>-->
<!--            &gt;-->
<!--        </button>-->
<!--    </section>-->
<!--    <section class="action flex flex-row justify-center">-->
<!--        <button class="outline mr-2 selectCompanionSceneFormBack" onclick|preventDefault={noCompanion}-->
<!--            >{$LL.companion.select.any()}</button-->
<!--        >-->
<!--        <button-->
<!--            type="submit"-->
<!--            class="light ml-2 selectCompanionSceneFormSubmit"-->
<!--            onclick|preventDefault={() => analyticsClient.selectWoka()}-->
<!--            onclick|preventDefault={selectCompanion}>{$LL.companion.select.continue()}</button-->
<!--        >-->
<!--    </section>-->

<!--</form>-->
<style>
    button {
        pointer-events: auto;
    }
</style>
